// extracted by mini-css-extract-plugin
export var legendIndicator = "_dl-1";
export var legendRight = "_dl-0";